const team2022 = {
  title: "2022",
  members: [
    {
      name: "message.team.management",
      members: [
        {
          img: "/static/team/members/simon_aubin_lavoie.jpg",
          fullName: "SIMON AUBIN-LAVOIE",
          role: "message.team.roles.captain",
          mail: "s.aubinlavoie.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/samuel_gagne.jpg",
          fullName: "SAMUEL GAGNÉ",
          role: "message.team.roles.technical-director",
          mail: "s.gagne.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/samuel-gagne-978529183",
        },
      ],
    },
    {
      name: "message.team.aerodynamic",
      members: [
        {
          img: "/static/team/members/xavier_brien.jpg",
          fullName: "XAVIER BRIEN",
          role: "message.team.roles.head-aerodynamics",
          mail: "x.brien.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/daniel_gavrila.jpg",
          fullName: "Daniel Gavrila",
          role: "",
          mail: "d.gavrila.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/antoine_gingras.jpg",
          fullName: "Antoine Gingras",
          role: "",
          mail: "a.gingras.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/antoine-gingras-227850236/`",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.chassis",
      members: [
        {
          img: "/static/team/members/samuel_gagne.jpg",
          fullName: "SAMUEL GAGNÉ",
          role: "message.team.roles.head-chassis",
          mail: "s.gagne.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/samuel-gagne-978529183",
        },
        {
          img: "/static/team/members/etienne_paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
      ],
    },
    {
      name: "message.team.dynamics",
      members: [
        {
          img: "/static/team/members/steve_groleau.jpg",
          fullName: "Steve Groleau",
          role: "message.team.roles.heade-dynamic",
          mail: "s.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/steve-groleau-1636a01b9/",
        },
        {
          img: "/static/team/members/charles_deschenes.jpg",
          fullName: "Charles Deschenes",
          role: "",
          mail: "c.deschenes.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/charles-deschenes-b1970829b/",
        },
        {
          img: "/static/team/members/alexandre_valsorda.jpg",
          fullName: "ALEXANDRE VALSORDA",
          role: "",
          mail: "a.valsorda.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/lea_bruneau.jpg",
          fullName: "LÉA BRUNEAU",
          role: "",
          mail: "l.bruneau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/l%C3%A9a-bruneau-6a045921b/",
        },
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "FELIX GROLEAU",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
        },
        {
          img: "/static/team/members/komi_kevin.jpg",
          fullName: "KOMI KEVIN AWATOR",
          role: "",
          mail: "k.awator.formule.ets@gmail.com",
          linkedin: "https://linkedin.com/in/kevin-awator",
        },
        {
          img: "/static/team/members/victor_avezard.jpg",
          fullName: "VICTOR AVEZARD",
          role: "",
          mail: "v.avezard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/victor-avezard",
        },
      ],
    },
    {
      name: "message.team.electronics",
      members: [
        {
          img: "/static/team/members/victor_avezard.jpg",
          fullName: "VICTOR AVEZARD",
          role: "message.team.roles.head-electronic",
          mail: "v.avezard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/victor-avezard",
        },
        {
          img: "/static/team/members/felix_paquet.jpg",
          fullName: "FÉLIX PAQUET",
          role: "",
          mail: "f.paquet.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/felix-paquet/",
        },
        {
          img: "/static/team/members/marc_antoine.jpg",
          fullName: "MARC-ANTOINE DOYON",
          role: "",
          mail: "ma.doyon.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/marc-antoine-doyon/",
        },
        {
          img: "/static/team/members/jerome_bolduc.jpg",
          fullName: "Jérôme Bolduc",
          role: "",
          mail: "j.bolduc.formule.ets@gmail.com",
          linkedin:
            "https://www.linkedin.com/in/j%C3%A9r%C3%B4me-bolduc-7083191b1/",
        },
      ],
    },
    {
      name: "message.team.power_n_drive",
      members: [
        {
          img: "/static/team/members/karl_vreeze.jpg",
          fullName: "KARL DE VREEZE",
          role: "message.team.roles.head-power-drive-meca",
          mail: "k.devreeze.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/karl-de-vreeze-89524b180/",
        },
        {
          img: "/static/team/members/jean_carlo.jpg",
          fullName: "JEAN-CARLO DORAY",
          role: "message.team.roles.head-power-drive-elec",
          mail: "jc.doray.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/jean-carlo-doray-b8614423b",
        },
        {
          img: "/static/team/members/tommy_gelinas.jpg",
          fullName: "Tommy Gélinas",
          role: "",
          mail: "t.gelinas.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/marc_antoine.jpg",
          fullName: "MARC-ANTOINE DOYON",
          role: "",
          mail: "ma.doyon.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/marc-antoine-doyon/",
        },
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "FELIX GROLEAU",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
        },
        {
          img: "/static/team/members/komi_kevin.jpg",
          fullName: "KOMI KEVIN AWATOR",
          role: "",
          mail: "k.awator.formule.ets@gmail.com",
          linkedin: "https://linkedin.com/in/kevin-awator",
        },
        {
            img: "/static/team/members/alek_cyr.jpg",
            fullName: "ALEK CYR",
            role: "",
            mail: "a.cyr.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/alek-cyr-9397b6192",
        }
      ],
    },
    {
      name: "message.team.machining",
      members: [
        {
          img: "/static/team/members/tommy_gelinas.jpg",
          fullName: "Tommy Gélinas",
          role: "",
          mail: "t.gelinas.formule.ets@gmail.com",
          linkedin: "",
        },
        {

          img: "/static/team/members/antoine_gingras.jpg",
          fullName: "Antoine Gingras",
          role: "",
          mail: "a.gringas.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/antoine-gingras-227850236/",
        },
        {
          img: "/static/team/members/alexandre_valsorda.jpg",
          fullName: "ALEXANDRE VALSORDA",
          role: "",
          mail: "a.valsorda.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/charles_deschenes.jpg",
          fullName: "Charles Deschenes",
          role: "",
          mail: "c.deschenes.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/charles-deschenes-b1970829b/",
        },
        {
          img: "/static/team/members/jimmy_jr.jpg",
          fullName: "JIMMY JR OZAETA",
          role: "",
          mail: "j.ozaeta.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/steve_groleau.jpg",
          fullName: "Steve Groleau",
          role: "",
          mail: "s.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/steve-groleau-1636a01b9/",
        },
      ],
    },
    {
      name: "message.team.sponsors_n_media",
      members: [
        {
          img: "/static/team/members/thomas_viejo.jpg",
          fullName: "Thomas Viejo",
          role: "message.team.roles.head-media-sponsors",
          mail: "t.viejo.formule.ets@gmail.com",
          linkedin:
            "https://www.linkedin.com/in/thomas-viejo-9a213b195/?originalSubdomain=fr",
        },
        {
          img: "/static/team/members/melina_gasparini.jpg",
          fullName: "MÉLINA GASPARINI",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/jimmy_jr.jpg",
          fullName: "JIMMY JR OZAETA",
          role: "",
          mail: "j.ozaeta.formule.ets@gmail.com",
          linkedin: "",
        },
        {
          img: "/static/team/members/gustave_dromain.jpg",
          fullName: "Gustave Dromain",
          role: "",
          mail: "g.dromain.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/gustave-dromain-9b590a181/"
         },
      ],
    },
  ],
};

export default team2022;
